// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ElectionCommitteeMemberKeysController from "./election_committee_member_keys_controller"
application.register("election-committee-member-keys", ElectionCommitteeMemberKeysController)

import CopyableController from "./copyable_controller"
application.register("copyable", CopyableController)

import ChartWithFormController from "./chart_with_form_controller"
application.register("chart-with-form", ChartWithFormController)

import SingleSelectController from "./single_select_controller"
application.register("single_select", SingleSelectController)

import DecisionSignatureController from "./decision_signature_controller"
application.register("decision-signature", DecisionSignatureController)

import CodeEditorController from "./code_editor_controller"
application.register("code-editor", CodeEditorController)

import ListFilterController from "./list_filter_controller"
application.register("list-filter", ListFilterController)

import TabHashController from "./tab_hash_controller"
application.register("tab-hash", TabHashController)

import GridBulkActionsController from "./grid_bulk_actions_controller"
application.register("grid-bulk-actions", GridBulkActionsController)

import TestApiController from "./test_api_controller"
application.register("test-api", TestApiController)

import TestSmtpConnectionController from "./test_smtp_connection_controller"
application.register("test-smtp-connection", TestSmtpConnectionController)

import RevealPasswordController from "./reveal_password_controller"
application.register("reveal-password", RevealPasswordController)

import LoginsHubsController from "./logins_hubs_controller"
application.register("logins-hubs", LoginsHubsController)

import BulkCountingController from "./bulk_counting_controller"
application.register("bulk-counting", BulkCountingController)

import VoterGroupImporterProgressController from "./voter_group_importer_progress_controller"
application.register("voter-group-importer-progress", VoterGroupImporterProgressController)

